// CB:BEGIN env-config
function inferIsDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const host = window.location.host || '';
    // CB:BEGIN dev-host-detection
    // Treat localhost and dev.corebids.com as dev hosts for showing Dev Nav in local runs
    const isLocal = /(^|\b)(localhost|127\.0\.0\.1)(:\d+)?$/i.test(host);
    const isDevSubdomain = /(^|\.)dev\.corebids\.com$/i.test(host);
    return isLocal || isDevSubdomain;
    // CB:END dev-host-detection
  } catch {
    return false;
  }
}

import { getApiBaseUrl } from '../lib/getApiUrl';

const viteEnv = (import.meta as any).env || {};

// Resolve API base URL at call time to avoid TDZ/circular init
export function getEnvApiBaseUrl(): string {
  return getApiBaseUrl();
}
export const isProduction: boolean = !!viteEnv.PROD || String(viteEnv.VITE_ENV).toLowerCase() === 'production';
export const isDevHost: boolean = inferIsDevHost();
// CB:BEGIN dev-pane-visibility
// Show dev pane when explicitly enabled or when running on dev host (including localhost)
export const showDevPane: boolean = String(viteEnv.VITE_SHOW_DEV_PANE).toLowerCase() === 'true' || isDevHost || (!isProduction && isDevHost);
// CB:END dev-pane-visibility
export const showLogs: boolean = String(viteEnv.VITE_SHOW_LOGS).toLowerCase() === 'true' || isDevHost || (!isProduction && isDevHost);
// CB:END env-config


